import React, { FunctionComponent } from 'react';
import styles from './PageTopBar.scss';
import { useIsMounted } from '../../hooks/useIsMounted';
import { usePageMeta } from '../../hooks';
import classNames from 'classnames';
import pageTypes from '../../constants/pageTypes';

export const PageTopBar: React.FunctionComponent = ({ children }) => {
  const isMounted = useIsMounted();
  const { pageType, isPreview } = usePageMeta();

  if (!isMounted) {
    return null;
  }

  const classes = classNames({
    [styles.fullScreenWrapper]: true,
    [styles.pageTopBarPreview]: isPreview && pageType === pageTypes.ONE_PAGE,
  });

  return <div className={classes}>{children}</div>;
};
